const processDeviations = (list, transData) => {
  let getContent = ''
  for (let j = 0; j < list.length; j++) {
    getContent += `<tr>
      <th class="th-fontsize">${transData.header.number}</th>
      <th class="th-fontsize" colspan="4">${transData.header.title}</th>
      <th class="th-fontsize">${transData.header.category}</th>
      <th class="th-fontsize">${transData.header.location}</th>
      <th class="th-fontsize">${transData.header.deadline}</th>
    </tr>`
    getContent += `<tr>
      <td>${list[j].number || ''}</th>
      <td colspan="4">${list[j].title || ''}</th>
      <td>${list[j].deviationcategory_name || ''}</th>
      <td>${list[j].deviationlocation_name || ''}</th>
      <td>${list[j].deadline || ''}</th>
    </tr>`
    getContent += `<tr>
      <th class="th-fontsize">${transData.header.status}</th>
      <th class="th-fontsize" colspan="2">${transData.header.severity}</th>
      <th class="th-fontsize" colspan="2">${transData.header.internalCost}</th>
      <th class="th-fontsize" colspan="2">${transData.header.customerCost}</th>
      <th class="th-fontsize">${transData.header.date}</th>
    </tr>`
    getContent += `<tr>
      <td>${list[j].deviationstatus_name || ''}</th>
      <td colspan="2">${list[j].severity_val || ''}</th>
      <td colspan="2">${list[j].estimated_internal_cost || ''}</th>
      <td colspan="2">${list[j].estimated_customer_cost || ''}</th>
      <td>${list[j].date || ''}</th>
    </tr>`
    getContent += '</tr>'
    getContent += list[j].ordernumber ? `<tr>
        <td colspan="3" class="wrapContent"><b>${transData.order} : </b>${list[j].ordernumber || ''} </td>
        <td colspan="5" class="wrapContent"><b>${transData.salesRef} : </b>${list[j].ordersalesreference || ''}</td>
      </tr>` : ''
    getContent += `<tr>
        <td colspan="8" class="wrapContent"><b>${transData.description} : </b>${list[j].description || ''}</td>
      </tr>
      <tr>
        <td colspan="8" class="wrapContent"><b>${transData.reason} : </b>${list[j].reason || ''}</td>
      </tr>
      <tr>
        <td colspan="8" class="wrapContent"><b>${transData.underlyingReason} : </b>${list[j].underlying_reason || ''}</td>
      </tr>
      <tr>
        <td colspan="8"><b>${transData.actions} : </b>${list[j].actions || ''}</td>
      </tr>
      <tr>
        <td colspan="8"><b>${transData.correctiveActions} : </b>${list[j].corrective_actions || ''}</td>
      </tr>
      <tr>
        <td colspan="8"><b>${transData.effectiveOfMeasures} : </b>${list[j].effective_of_measures || ''}</td>
      </tr>`
    if (list[j].measures && list[j].measures.length > 0) {
      getContent += `<tr>
          <td colspan="8"><b>${transData.measure}<b></td>
        </tr>
        <tr>
          <th colspan="4" class="th-fontsize">${transData.measureTitle}</th>
          <th colspan="2" class="th-fontsize">${transData.measureIncharge}</th>
          <th colspan="1" class="th-fontsize">${transData.measureDeadline}</th>
          <th colspan="2" class="th-fontsize">${transData.measureStatus}</th>
        </tr>`
      for (let k = 0; k < list[j].measures.length; k++) {
        getContent += `<tr>
          <td colspan="4">${list[j].measures[k].title || ''}</td>
          <td colspan="2">${list[j].measures[k].inchargeuser_name || ''}</td>
          <td colspan="1">${list[j].measures[k].deadline || ''}</td>
          <td colspan="2">${list[j].measures[k].status_name || ''}</td>
        </tr>`
      }
    }
    if (j < (list.length - 1)) {
      getContent += `<tr>
        <td colspan="9"></td>
      </tr>`
    }
  }
  return content(getContent, transData)
}
const content = (content, transData) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<!DOCTYPE html><html><head><meta name="viewport" content="width=device-width" />
<meta charset="utf-8"/>
<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet" />
<style>
  .wrapContent { word-break: break-all; }
  table {
    border-collapse: collapse;
  }
  td, th {
    border: 1px solid black;
  }
</style>
</head>
<body>
<div class="container">
  <table class="table">
    <tbody>
      <tr height="60px">
        <td align="center" style="border: none !important;vertical-align: middle;">
          <div>
          <img height="40" width="140" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
          </div>
        </td>
        <td align="right" style="border: none !important;vertical-align: middle !important;" width="100%">
          <font size="6">
            <b>
             ${transData.report}
            </b>
          </font>
        </td>
      </tr>
    </tbody>
  </table>
  <table class="table table-bordered" style="width: 100%">
    <tbody>
      ${content}
    </tbody>
  </table>
</div>
</body></html>`)))
export default processDeviations
